import { render } from "./DeviationCrewTable.vue?vue&type=template&id=75f4c378"
import script from "./DeviationCrewTable.vue?vue&type=script&lang=ts"
export * from "./DeviationCrewTable.vue?vue&type=script&lang=ts"
script.render = render

export default script